import {stringToDate} from "./stringToDate";
export function decorateDateString(string) {
    const dateObject = stringToDate(string);
    const now = new Date();
    const diffMs = now - dateObject; // difference in milliseconds
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

    // Helper: format the date in dd.mm.yy
    const formattedDate = $.datepicker.formatDate('dd.mm.yy', dateObject);

    // Check if the date is today, yesterday, or the day before yesterday
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffDays = Math.floor((today - new Date(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate())) / (1000 * 60 * 60 * 24));

    if (diffMinutes < 60 && diffDays === 0) {
        // Less than 1 hour ago
        return `vor ${diffMinutes} Minute${diffMinutes === 1 ? '' : 'n'}`;
    }
    if (diffHours < 24 && diffDays === 0) {
        // Less than 24 hours ago
        return `vor ${diffHours} Stunde${diffHours === 1 ? '' : 'n'}`;
    }
    if (diffDays === 1) {
        return "Gestern";
    }
    if (diffDays === 2) {
        return "Vorgestern";
    }
    return formattedDate;
}
